import React, { useEffect, useState } from "react";
import { fireDB } from "../../firebase/FirebaseConfig";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { useParams, useNavigate } from "react-router-dom";
import { Container, Form, Button, Card } from "react-bootstrap";

const EditBlog = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [thumbnail, setThumbnail] = useState("");
    const [shortDesc, setShortDesc] = useState("");
    const [content, setContent] = useState("");

    const [loading, setLoading] = useState(false);

    // Load existing blog data
    const getBlogData = async () => {
        const docRef = doc(fireDB, "blogs", id);
        const snap = await getDoc(docRef);

        if (snap.exists()) {
            const data = snap.data();

            setTitle(data.title);
            setThumbnail(data.thumbnail);
            setShortDesc(data.shortDesc);
            setContent(data.content);
        }
    };

    useEffect(() => {
        getBlogData();
    }, []);

    // Update blog
    const updateBlog = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const docRef = doc(fireDB, "blogs", id);

            await updateDoc(docRef, {
                title,
                thumbnail,
                shortDesc,
                content,
            });

            setLoading(false);
            alert("Blog Updated Successfully!");
            navigate("/blog");
        } catch (error) {
            setLoading(false);
            console.log(error);
            alert("Error updating blog");
        }
    };

    return (
        <Container className="my-5">
            <Card className="p-4 shadow rounded-4">
                <h2 className="fw-bold text-center mb-4">✏️ Edit Blog</h2>

                <Form onSubmit={updateBlog}>
                    {/* Title */}
                    <Form.Group className="mb-3">
                        <Form.Label>Blog Title</Form.Label>
                        <Form.Control
                            type="text"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* Thumbnail */}
                    <Form.Group className="mb-3">
                        <Form.Label>Thumbnail URL</Form.Label>
                        <Form.Control
                            type="text"
                            value={thumbnail}
                            onChange={(e) => setThumbnail(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* Short Description */}
                    <Form.Group className="mb-3">
                        <Form.Label>Short Description</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={shortDesc}
                            onChange={(e) => setShortDesc(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* Main Content */}
                    <Form.Group className="mb-4">
                        <Form.Label>Full Blog Content</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={10}
                            value={content}
                            onChange={(e) => setContent(e.target.value)}
                            required
                        />
                    </Form.Group>

                    <Button
                        type="submit"
                        className="w-100 fw-bold"
                        variant="primary"
                        disabled={loading}
                    >
                        {loading ? "Updating..." : "Update Blog"}
                    </Button>
                </Form>
            </Card>
        </Container>
    );
};

export default EditBlog;
